import { jsx, Fragment } from "react/jsx-runtime";
import { ElementRenderer } from "./ElementRenderer.js";
import { LeafRenderer } from "./LeafRenderer.js";
const renderChildren = (children, options) => {
  if (!Array.isArray(children)) {
    children = [children];
  }
  return /* @__PURE__ */ jsx(Fragment, { children: children.map((child, i) => {
    if ("text" in child) {
      return /* @__PURE__ */ jsx(LeafRenderer, { leaf: child, renderLeaf: options.renderLeaf }, i);
    }
    if ("children" in child) {
      return /* @__PURE__ */ jsx(ElementRenderer, { element: child, options, children: renderChildren(child.children, options) }, i);
    }
    return null;
  }) });
};
export {
  renderChildren
};
//# sourceMappingURL=renderChildren.js.map
